module.exports = __webpack_public_path__ + "static/img/29.445b24b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/29.png
// module id = JlBd
// module chunks = 1